import React, { useState } from "react";
import { UserCard } from "../UserCard";
import { CurrentUser } from "../../bitmaker";

interface Props {
  user?: CurrentUser;
  loginSuccess: (expiresIn: number) => void;
  logoutSuccess: () => void;
}

export const Navbar: React.FC<Props> = (props) => {
  const [showMenu, setShowMenu] = useState(false);
  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  return (
    <div className="navbar-container">
      <nav className="navbar-top flex items-center justify-between px-4 py-2 sm:px-6 lg:px-8">
        <div className={`navbar-links ${showMenu ? "show" : ""}`}>
          <div>
            <a href={"/"}>Home</a>
          </div>
          <div>
            <a href={`/users/${props.user?.login}`}>My Profile</a>
          </div>
          <div>
            <a href={"/projects"}>Projects</a>
          </div>
          {props.user?.permissions.can_access_accounts ? (
            <div>
              <a href={"/accounts"}>Accounts</a>
            </div>
          ) : null}
          {props.user?.permissions.can_access_members_information ? (
            <div>
              <a href={"/users"}>Members Information</a>
            </div>
          ) : null}
          {props.user?.permissions.can_access_sales ? (
            <div>
              <a href={"/sales"}>Sales</a>
            </div>
          ) : null}
          {props.user?.permissions.can_access_leads ? (
            <div>
              <a href={"/leads"}>Leads</a>
            </div>
          ) : null}
          {props.user?.permissions.can_access_invoices ? (
            <div>
              <a href={"/invoices"}>Invoices</a>
            </div>
          ) : null}
          {props.user?.permissions.can_access_billing ? (
            <div>
              <a href={"/billing"}>Billing</a>
            </div>
          ) : null}
          {props.user?.permissions.can_access_audit ? (
            <div>
              <a href={"/audit"}>Audit</a>
            </div>
          ) : null}
          <div>
            <a href={"/professional_services_kpis"}>
              Professional Services KPIs
            </a>
          </div>
        </div>
        <div className="navbar-avatar-container">
          <UserCard
            user={props.user}
            loginSuccess={props.loginSuccess}
            logoutSuccess={props.logoutSuccess}
          />
        </div>
        <div className="hamburger-menu" onClick={toggleMenu}>
          <div className={`hamburger-line ${showMenu ? "active" : ""}`}></div>
          <div className={`hamburger-line ${showMenu ? "active" : ""}`}></div>
          <div className={`hamburger-line ${showMenu ? "active" : ""}`}></div>
        </div>
      </nav>
    </div>
  );
};
